import React, { useCallback, useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { WebsitesCardComponent } from '../components/website-card.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectWebsiteCardsListItems } from '../../../../../redux/websiteCards/selector';
import { deepCopy, transformBackCardValues, transformCardValues } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import { websiteCards } from '../../../../../redux/websiteCards/action';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import storePersist from '../../../../../redux/storePersist';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { products } from '../../../../../redux/products/action';
import { categories } from '../../../../../redux/categories/action';
import { selectProductsListItems } from '../../../../../redux/products/selector';


let currentChange: any = {}
const ManagementWebsiteCard = () => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const { platformWebSiteId, id } = useParams()
  const productsData = useSelector(selectProductsListItems)
  const categoriesData = useSelector(selectCategoriesListItems)
  const orderItems = useSelector(selectWebsiteCardsListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const [
    cardValues,
    setCardValues
  ] = useState<any>([]);
  const [
    cardTemplate,
    setCardTemplate
  ] = useState<any>([]);

  const [
    tenantWebCards,
    setTenantWebCards
  ] = useState<any>([]);
  const [
    cardImageIndex,
    setCardImageIndex
  ] = useState<any>([])
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(50);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalProductOpen, setIsProductModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenProductModal = () => setIsProductModalOpen(true);
  const handleCloseProductModal = () => setIsProductModalOpen(false);
  const [cardDetailInfo, setCardDetailInfo] = useState([{}])
  const librariesItems = storePersist?.get("library")?.current;
  const cardTypes = librariesItems?.CardType
  const [
    categoryColumnDefs,
    setCategoryColumnDefs
  ] = useState({});
  const createCategoryColumnDefs: any = () => {
    setCategoryColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      { field: 'CategoryName', headerName: 'Category Name', isEdit: true },
      { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
      { field: 'DisplayOrder', headerName: 'Display Order' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }

    ]);
  }

  const [
    productColumnDefs,
    setProductColumnDefs
  ] = useState({});
  const createProductColumnDefs: any = () => {
    setProductColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      {
        field: 'Message.MediaMappings.MediaFiles[0].FileMappingURL',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',

      },
      {
        field: 'Message.ProductCode',
        headerName: 'Product Code',
        sortable: true,
        filter: true,

      },
      {
        field: 'Message.Name',
        headerName: 'Name',
        sortable: true,
        filter: true,
        isEdit: true,
      },
      { field: 'Message.UOMName', headerName: 'UOM Name', filter: true },
      {
        field: 'Message.Price',
        headerName: 'Price',
        sortable: true,
        isCurrencyValueFormat: true,
      },
      { field: 'Message.StockQuantity', headerName: 'StockQuantity' },
      {
        field: 'Message.IsPublishedInCSP',
        headerName: 'Published In CSP',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.IsPublishedInOpenNetwork',
        headerName: 'Published In OpenNetwork',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.sPublishedInService',
        headerName: 'Published In Service',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.IsAvailable',
        headerName: 'Avilable',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.CreatedOnUtc',
        headerName: 'Created On',
        isDateValueFormat: true,
        sortable: true,
      },

    ]);
  }
  const handleFormChange: any = ({ field, value, idx }: any) => {
    const items = deepCopy(cardValues);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setCardValues(items);
  }
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const changeCardFile = (idx: number, templateField: any, fileType: any) => {
    setCardImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: cardValues[idx][templateField],
      folder: 'website',
      type: fileType
    })
    currentChange = { idx, templateField }
  }
  const handleSubmit = (data: any) => {
    cardValues[cardImageIndex][currentChange.templateField] = data
    const localSelectedMedia = addNewRow({ cardValuesArg: cardValues });
    setCardValues(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }
  const fetchTenantWebsiteCardsById = () => {
    dispatch(websiteCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
      entity: 'websiteCards',
      jsonData: {
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          },
          {
            "FieldName": "PlatformWebSiteId",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": platformWebSiteId
          },
          {
            "FieldName": "Id",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": id
          }
        ],
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const addNewRow = ({ cardValuesArg }: any) => {
    const localCardValues = deepCopy(cardValuesArg);
    let newCardValueRecord = {};

    // Create a new empty row based on the template
    R.map((template: any) => {
      newCardValueRecord = R.assoc(template.field, '', newCardValueRecord);
      return newCardValueRecord;
    })(cardTemplate);

    // Get the last row in localCardValues
    const lastRow = localCardValues[localCardValues.length - 1];

    // Check if the last row contains 'product' or 'category'
    const hasProductOrCategory = lastRow?.product || lastRow?.category;

    // Check if the last row is filled with any other data
    const isLastRowFilledWithData = R.any(R.complement(R.isEmpty))(R.values(lastRow));

    // Add a new empty row only if there's no product or category in the last row
    if (localCardValues.length === 0 || (isLastRowFilledWithData && !hasProductOrCategory)) {
      localCardValues.push(newCardValueRecord);
    }

    return localCardValues;
  }
  const getIsWebPageCard = () => currentChange.field === 'title' || currentChange.field === 'src' || currentChange.field === 'subtitle'
  const setTenantWebsiteCardInfo = async () => {
    let localCardItems = deepCopy(cardValues)
    localCardItems.splice(
      currentChange.idx,
      1,
      { ...localCardItems[currentChange.idx] }
    );
    localCardItems = addNewRow({ cardValuesArg: localCardItems });

    currentChange.field = getIsWebPageCard()
    setCardValues(localCardItems)
  }
  const back = () => {
    navigate(`/management/cms/websites/${platformWebSiteId}`)
  }


  useEffect(
    () => {
      dispatch(products.list({
        url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
        entity: 'products',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
        .then(() => {
          dispatch(categories.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
            entity: 'categories',
            jsonData: {
              "Filters": [
                {
                  "FieldName": "IncludeInTopMenu",
                  "FilterOperatorId": 1,
                  "FieldValue": true,
                  "FieldType": "boolean"
                }
              ],
              "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",
            }
          }))
        })
      createCategoryColumnDefs()
      createProductColumnDefs()
      if (Number(id) > 0) {

        fetchTenantWebsiteCardsById()
        setIsLoading(false)
      }
    },
    [pageData]
  )


  useEffect(() => {
    if (isQuery) {
      const clonedItems = _.cloneDeep(orderItems?.result?.items[0]);
      if (!clonedItems) return;
      setTenantWebCards(clonedItems);
      const parsedCardValue = JSON.parse(clonedItems?.CardValue || '[]');
      if (clonedItems?.CardTypeId !== 0 && clonedItems?.CardTypeId !== 10 && clonedItems?.CardTypeId !== 80) {
        setCardDetailInfo({ ...JSON.parse(JSON.stringify(parsedCardValue)) });
      }
      else if (clonedItems?.CardTypeId === 80) {
        const parsedTemplate = JSON.parse(orderItems?.result?.items[0]?.CardValue || '[]');
        if (parsedTemplate.length > 0) {
          setCardTemplate(parsedTemplate);
        }
      }
      else {
        const parsedTemplate = JSON.parse(orderItems?.result?.items[0]?.CardValue || '[]');
        if (parsedTemplate.length > 0) {
          setCardTemplate(parsedTemplate[0]);
        }
        const localCard = addNewRow({ cardValuesArg: transformCardValues(parsedTemplate) });
        setCardValues(localCard);
      }
    }
  }, [isQuery, orderItems]);

  useEffect(
    () => {
      if (currentChange.field) {
        setTenantWebsiteCardInfo()
      }
    },
    [cardValues]
  )
  const handleDeleteCollectionCard = async () => {
    const backTransformedCard = transformBackCardValues(JSON.stringify(cardValues))
    await dispatch(websiteCards.resetAction({ actionType: 'update' }))
    await dispatch(websiteCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'tenantWebsiteCards', jsonData: {

        Records: [
          {
            context: {},
            message: {
              CardName: tenantWebCards?.CardName || "",
              TenantId: tenantId,
              Id: tenantWebCards?.Id,
              StoreId: tenantWebCards?.StoreId,
              DepartmentId: tenantWebCards?.DepartmentId,
              WebSiteName: tenantWebCards?.WebsiteName,
              PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
              PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
              PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
              PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
              CardValue: backTransformedCard,
              CardTypeId: tenantWebCards?.CardTypeId,
              CardVersionId: tenantWebCards?.CardVersionId || 0,
              Remarks: tenantWebCards?.Remarks,
              HostingUrl: tenantWebCards?.HostingUrl,
              MappedDomain: tenantWebCards?.MappedDomain,
              DisplayOrder: tenantWebCards?.DisplayOrder || 0,
              DBNIEId: tenantWebCards?.DBNIEId || 0,
              DBNPId: tenantWebCards?.DBNPId || 0,
              DBNPRegistryId: tenantWebCards?.DBNPRegistryId || 0,
              DBAId: tenantWebCards?.DBAId || 0,
              GlobalOrgRegistryId: tenantWebCards?.GlobalOrgRegistryId || 0
            }
          }
        ]

      }
    })).then(() => {
      back()
    })

  }
  const deleteTenantwebCardItem = async (Item: any, index: any) => {
    if (!selectedRows) {
      handleDeleteCollectionCard()
    }

    else {
      const card = deepCopy(cardValues)
      card.splice(
        index,
        1
      )

      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      await dispatch(websiteCards.resetAction({ actionType: 'update' }))
      await dispatch(websiteCards.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'websiteCards', jsonData: {

          Records: [
            {
              context: {},
              message: {
                TenantId: tenantId,
                Id: tenantWebCards?.Id,
                StoreId: tenantWebCards?.StoreId,
                DepartmentId: tenantWebCards?.DepartmentId,
                WebSiteName: tenantWebCards?.WebsiteName,
                PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
                PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
                PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
                PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
                CardValue: backTransformedCard,
                CardTypeId: tenantWebCards?.CardTypeId,
                CardVersionId: tenantWebCards?.CardVersionId || 0,
                Remarks: tenantWebCards?.Remarks,
                HostingUrl: tenantWebCards?.HostingUrl,
                MappedDomain: tenantWebCards?.MappedDomain,
                DisplayOrder: tenantWebCards?.DisplayOrder || 0,
                CardName: tenantWebCards?.CardName || "",
                DBNIEId: tenantWebCards?.DBNIEId || 0,
                DBNPId: tenantWebCards?.DBNPId || 0,
                DBNPRegistryId: tenantWebCards?.DBNPRegistryId || 0,
                DBAId: tenantWebCards?.DBAId || 0,
                GlobalOrgRegistryId: tenantWebCards?.GlobalOrgRegistryId || 0
              }
            }
          ]

        }
      })).then(() => {
        back()
      })

    }

  }
  const handleCollectionsCard = async () => {
    const selectedCards = cardValues.map((item: any) => {
      const cardValueData = {
        field: item?.field,
        value: item?.value,
        type: item?.type
      }
      return cardValueData
    })
    const backTransformedCard = JSON.stringify(selectedCards)
    await dispatch(websiteCards.resetAction({ actionType: 'update' }))
    await dispatch(websiteCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'tenantWebsiteCards', jsonData: {

        Records: [
          {
            Context: {},
            Message: {
              TenantId: tenantId,
              Id: tenantWebCards?.Id,
              StoreId: tenantWebCards?.StoreId,
              DepartmentId: tenantWebCards?.DepartmentId,
              WebSiteName: tenantWebCards?.WebsiteName,
              PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
              PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
              PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
              PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
              CardValue: backTransformedCard,
              CardTypeId: tenantWebCards?.CardTypeId,
              CardVersionId: tenantWebCards?.CardVersionId || 0,
              Remarks: tenantWebCards?.Remarks,
              HostingUrl: tenantWebCards?.HostingUrl || "",
              MappedDomain: tenantWebCards?.MappedDomain || "",
              DisplayOrder: tenantWebCards?.DisplayOrder || 0,
              CardName: tenantWebCards?.CardName || "",
              DBNIEId: tenantWebCards?.DBNIEId || 0,
              DBNPId: tenantWebCards?.DBNPId || 0,
              DBNPRegistryId: tenantWebCards?.DBNPRegistryId || 0,
              DBAId: tenantWebCards?.DBAId || 0,
              GlobalOrgRegistryId: tenantWebCards?.GlobalOrgRegistryId || 0
            }
          }
        ]

      }
    })).then(() => {
      back()
    })
  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (tenantWebCards?.CardTypeId !== 0 && tenantWebCards?.CardTypeId !== 10 && tenantWebCards?.CardTypeId !== 80) {
      const cardDetailInfoCopy = JSON.stringify(_.cloneDeep(tenantWebCards?.cardDetailInfo));
      await dispatch(websiteCards.resetAction({ actionType: 'update' }))
      await dispatch(websiteCards.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'cards', jsonData: {

          Records: [
            {
              context: {},
              Message: {
                TenantId: tenantId,
                Id: tenantWebCards?.Id,
                StoreId: tenantWebCards?.StoreId,
                DepartmentId: tenantWebCards?.DepartmentId,
                WebSiteName: tenantWebCards?.WebsiteName,
                PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
                PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
                PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
                PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
                CardValue: cardDetailInfoCopy || tenantWebCards?.CardValue,
                CardTypeId: tenantWebCards?.CardTypeId,
                CardVersionId: tenantWebCards?.CardVersionId || 0,
                Remarks: tenantWebCards?.Remarks,
                HostingUrl: tenantWebCards?.HostingUrl || "",
                MappedDomain: tenantWebCards?.MappedDomain || "",
                DisplayOrder: tenantWebCards?.DisplayOrder || 0,
                CardName: tenantWebCards?.CardName || "",
                DBNIEId: tenantWebCards?.DBNIEId || 0,
                DBNPId: tenantWebCards?.DBNPId || 0,
                DBNPRegistryId: tenantWebCards?.DBNPRegistryId || 0,
                DBAId: tenantWebCards?.DBAId || 0,
                GlobalOrgRegistryId: tenantWebCards?.GlobalOrgRegistryId || 0
              }
            }
          ]

        }
      })).then(() => {
        back()
      })
    }

    else if (tenantWebCards?.CardTypeId === 80) {
      handleCollectionsCard()
    }
    else {
      const card = deepCopy(cardValues)
      card.splice(
        card.length - 1,
        1
      )

      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      await dispatch(websiteCards.resetAction({ actionType: 'update' }))
      await dispatch(websiteCards.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'websiteCards', jsonData: {

          Records: [
            {
              Context: {},
              Message: {
                TenantId: tenantId,
                Id: tenantWebCards?.Id,
                StoreId: tenantWebCards?.StoreId,
                DepartmentId: tenantWebCards?.DepartmentId,
                WebSiteName: tenantWebCards?.WebsiteName,
                PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
                PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
                PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
                PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
                CardValue: backTransformedCard,
                CardTypeId: tenantWebCards?.CardTypeId,
                CardVersionId: tenantWebCards?.CardVersionId || 0,
                Remarks: tenantWebCards?.Remarks,
                HostingUrl: tenantWebCards?.HostingUrl || "",
                MappedDomain: tenantWebCards?.MappedDomain || "",
                DisplayOrder: tenantWebCards?.DisplayOrder || 0,
                CardName: tenantWebCards?.CardName || "",
                DBNIEId: tenantWebCards?.DBNIEId || 0,
                DBNPId: tenantWebCards?.DBNPId || 0,
                DBNPRegistryId: tenantWebCards?.DBNPRegistryId || 0,
                DBAId: tenantWebCards?.DBAId || 0,
                GlobalOrgRegistryId: tenantWebCards?.GlobalOrgRegistryId || 0
              }
            }
          ]

        }
      })).then(() => {
        back()
      })

    }

  }
  const handleSelect = useCallback((selectedRow) => {
    console.log("Selected Rows:", selectedRow);
    setSelectedRows(selectedRow);
  }, []);

  const handleAddCollections = () => {
    if (selectedRows[0]?.Message?.ProductCode) {
      const updatedCardValues = transformCardValue(selectedRows, cardTemplate);
      setCardValues(updatedCardValues);
      handleCloseProductModal()
    }
    if (selectedRows[0]?.CategoryName || selectedRows[0]?.CategoryCode) {
      const updatedCardValues = transformCardValueCategory(selectedRows, cardTemplate);
      setCardValues(updatedCardValues);
      handleCloseModal()
    }

  };

  const transformCardValueCategory = (selectedRows: any[], cardTemplate: any[]): any[] => {
    return cardTemplate.map(template => {
      if (template.field === 'category') {
        return {
          field: 'category',
          type: 'text',
          value: selectedRows
        };
      } else {
        return {
          field: template.field,
          type: template.type,
          value: '' // Default value for other fields
        };
      }
    });
  };

  const transformCardValue = (selectedRows: any[], cardTemplate: any[]): any[] => {
    return selectedRows.map(row => {
      const transformedCard: any = {};
      const message = row?.Message || {};
      cardTemplate.forEach(template => {
        const field = template.field;
        if (field === 'src' && message?.MediaMappings?.MediaFiles?.length) {
          transformedCard[field] = message.MediaMappings.MediaFiles[0]?.FileMappingURL || '';
        }
        else if (field === 'id' || field === 'productId') {
          transformedCard[field] = message?.Id || '';
        }
        else if (field === 'name' || field === 'productName') {
          transformedCard[field] = message?.Name || '';
        } else if (field === 'code' || field === 'productCode') {
          transformedCard[field] = message?.ProductCode || '';
        } else if (field === 'price') {
          transformedCard[field] = message?.Price || '';
        }
        else if ((field === 'productCombinationId' || 'combinationId') && message?.ProductAttributeCombinations) {
          transformedCard[field] = message?.ProductAttributeCombinations?.ProductAttributeCombinationId || '';
        }
        else if (field === 'vendorName') {
          transformedCard[field] = message?.VendorName || '';
        } else if (field === 'description') {
          transformedCard[field] = message?.Description || '';
        } else if (field === 'product') {
          transformedCard[field] = row
        } else {
          // transformedCard[field] = '';
        }
      });

      return transformedCard;

    });

  };


  const additionButtons: any = [
    {
      name: 'Add Collection',
      callback: () => handleAddCollections(),
    }
  ];


  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={id}
        tenantId={tenantId}
      />}
      {isLoading ? <PageLoader /> :
        <WebsitesCardComponent
          cardDetailInfo={cardDetailInfo}
          tenantWebCards={tenantWebCards}
          cardTypes={cardTypes}
          handleFormSubmit={handleFormSubmit}
          back={back}
          cardTemplate={cardTemplate}
          cardValues={cardValues}
          handleFormChange={handleFormChange}
          deleteTenantwebCardItem={deleteTenantwebCardItem}
          changeCardFile={changeCardFile}
          products={productsData?.result?.items}
          categories={categoriesData?.result?.items}
          categoryColumnDefs={categoryColumnDefs}
          setPageData={setPageData}
          categoriesPaginationData={categoriesData?.result?.pagination}
          productsPaginationData={productsData?.result?.pagination}
          productColumnDefs={productColumnDefs}
          setPageSize={setPageSize}
          onSelect={handleSelect}
          additionButtons={additionButtons}
          isModalOpen={isModalOpen}
          isModalProductOpen={isModalProductOpen}
          handleOpenModal={handleOpenModal}
          handleCloseModal={handleCloseModal}
          handleOpenProductModal={handleOpenProductModal}
          handleCloseProductModal={handleCloseProductModal}
        />
      }
    </>


  )

}

export default ManagementWebsiteCard;